"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Earth = _interopRequireDefault(require("@berlitz/streamline-icons/lib/regular/48-Maps-Navigation/13-Earth/Earth3"));
var _TopNav = require("../../TopNav.style");
var _DropDown = _interopRequireDefault(require("../DropDown"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var LanguageDropDown = function LanguageDropDown(_ref) {
  var isDark = _ref.isDark,
    languageLinks = _ref.languageLinks,
    activeDropDown = _ref.activeDropDown,
    activeLanguage = _ref.activeLanguage,
    handleDropDownFocus = _ref.handleDropDownFocus;
  return /*#__PURE__*/_react.default.createElement(_TopNav.ColumnRight, {
    "data-key": "top-nav__top-bar__right",
    "aria-label": "Secondary Navigation Menu"
  }, /*#__PURE__*/_react.default.createElement(_DropDown.default, {
    link: {
      label: activeLanguage
    },
    isDark: isDark,
    className: activeDropDown === 'Language' ? 'focus' : '',
    onFocus: function onFocus() {
      return handleDropDownFocus('Language');
    },
    icon: /*#__PURE__*/_react.default.createElement(_Earth.default, {
      size: "sm",
      color: isDark ? 'brand02' : 'brand03'
    }),
    key: "top-nav__top-bar__locale-selector",
    "data-key": "top-nav__top-bar__locale-selector"
  }, languageLinks.map(function (languageLink, index) {
    return /*#__PURE__*/_react.default.createElement(_TopNav.SubNavItem, {
      key: "top-nav__top-bar__locale-option-".concat(index),
      dataKey: "top-nav__top-bar__locale-option-".concat(index),
      role: "menuitem"
    }, languageLink);
  })));
};
var _default = LanguageDropDown;
exports.default = _default;